import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	container: {
		display: "flex",
		flexDirection: "column",
		height: "100%",
		width: "100%",
		backgroundColor: tokens.colorNeutralBackground4,
	},
	tabsAndToggledViewsContainer: {
		width: "100%",
		height: "100%",
		display: "flex",
		...shorthands.overflow("hidden", "hidden"),
	},
	resizeHintLeft: {
		right: "-7px",
	}
});
